import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0A0A0A] pt-20 pb-16 lg:pt-0 lg:pb-0" data-id="element-103">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-104">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-[#22C55E]/10 rounded-full blur-[100px]" data-id="element-105" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-[#F59E0B]/10 rounded-full blur-[100px]" data-id="element-106" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-107">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-108">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-start text-left" data-id="element-109">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#22C55E]/10 border border-[#22C55E]/20 text-[#22C55E] font-semibold text-sm mb-6 tracking-wide uppercase" data-id="element-110">
              Disciplina Diaria para Resultados Reales
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 tracking-tight" data-id="element-111">
              MICRO<span className="text-[#22C55E]" data-id="element-112">VICTORIAS</span>
            </h1>

            <h2 className="text-2xl sm:text-3xl font-bold text-gray-300 mb-6" data-id="element-113">
              Pequeños Hábitos que Transforman tu Cuerpo
            </h2>

            <p className="text-lg text-gray-400 mb-8 max-w-xl leading-relaxed" data-id="element-114">
              Olvídate de las dietas extremas. Construye un estilo de vida
              sostenible con micro-hábitos que generan resultados asombrosos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-115">
              <Button size="xl" glow className="w-full sm:w-auto text-lg shadow-lg shadow-[#22C55E]/20" onClick={() => {
              document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-116">
                ¡Quiero mi copia ahora!
              </Button>
            </div>

            <div className="mt-6 flex items-center gap-4 text-sm text-gray-500" data-id="element-117">
              <div className="flex items-center gap-1.5" data-id="element-118">
                <CheckCircle2 className="w-4 h-4 text-[#22C55E]" data-id="element-119" />
                <span data-id="element-120">Descarga inmediata</span>
              </div>
              <div className="w-1 h-1 rounded-full bg-gray-700" data-id="element-121" />
              <div className="flex items-center gap-1.5" data-id="element-122">
                <CheckCircle2 className="w-4 h-4 text-[#22C55E]" data-id="element-123" />
                <span data-id="element-124">Formato digital</span>
              </div>
              <div className="w-1 h-1 rounded-full bg-gray-700" data-id="element-125" />
              <div className="flex items-center gap-1.5" data-id="element-126">
                <CheckCircle2 className="w-4 h-4 text-[#22C55E]" data-id="element-127" />
                <span data-id="element-128">Guía paso a paso</span>
              </div>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative flex justify-center lg:justify-end" data-id="element-129">
            <a href="https://lifestylevilofitness.com/cart/42172863742027:1" target="_blank" rel="noopener noreferrer" className="relative w-full max-w-md lg:max-w-lg aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl shadow-[#22C55E]/20 border border-gray-800 group block cursor-pointer" data-id="element-130">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-60 z-10" data-id="element-131" />
              <img src="https://cdn.magicpatterns.com/uploads/7HQvQVzcWY35ZJxRjyZpm3/ChatGPT_Image_13_mar_2026,_15_47_00.png" alt="Portada del ebook Microvictorias" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-132" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 right-6 z-20 bg-[#0A0A0A]/90 backdrop-blur-md border border-[#F59E0B]/30 p-4 rounded-xl shadow-lg" data-id="element-133">
                <div className="flex items-center gap-3" data-id="element-134">
                  <div className="bg-[#F59E0B] rounded-full p-2" data-id="element-135">
                    <CheckCircle2 className="w-6 h-6 text-black" data-id="element-136" />
                  </div>
                  <div data-id="element-137">
                    <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold" data-id="element-138">
                      Resultados
                    </p>
                    <p className="text-white font-bold" data-id="element-139">100% Reales</p>
                  </div>
                </div>
              </div>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}